var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "tile is-ancestor is-parent" }, [
    _c("div", { staticClass: "tile is-parent is-vertical" }, [
      _c(
        "article",
        { staticClass: "tile is-child box" },
        [
          _c("div", { staticClass: "columns is-gapless" }, [
            _c(
              "div",
              { staticClass: "column" },
              [
                _c("p", { staticClass: "title" }, [_vm._v("Other Purchases")]),
                _c("subtitle-totals", {
                  attrs: {
                    labels: ["Total"],
                    totals: [_vm.otherPurchasesTotal],
                    shows: [true],
                  },
                }),
              ],
              1
            ),
            !_vm.readOnlyView
              ? _c("div", { staticClass: "column" }, [
                  _c("div", { staticClass: "control is-pulled-right" }, [
                    _c("div", { staticClass: "field-body" }, [
                      _c(
                        "div",
                        {
                          staticClass: "field",
                          staticStyle: { "margin-right": "0.5em" },
                        },
                        [
                          !_vm.isLockPurchaseOrder
                            ? _c("div", { staticClass: "buttons" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "button is-primary tooltip is-tooltip-topright",
                                    attrs: {
                                      "data-tooltip": "Add new item",
                                      disabled: _vm.isLockPurchaseOrder,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.addNewOtherPurchases()
                                      },
                                    },
                                  },
                                  [
                                    _c("span", { staticClass: "icon" }, [
                                      _c("i", {
                                        staticClass: "mdi",
                                        class: { "mdi-plus": true },
                                      }),
                                    ]),
                                    _c("span", [_vm._v(_vm._s("Add"))]),
                                  ]
                                ),
                              ])
                            : _c("div", [_c("order-lock-notification")], 1),
                        ]
                      ),
                    ]),
                  ]),
                ])
              : _vm._e(),
          ]),
          _c(
            "bulma-table",
            {
              staticClass:
                "table is-bordered is-striped is-narrow is-fullwidth",
              attrs: {
                columns: _vm.columns,
                "page-index": 1,
                "page-size": 100,
                "total-rows": _vm.activeItems.length,
                "show-pagination": false,
                "is-loading": _vm.isTableLoading,
                "sort-column": _vm.sortColumn,
                "sort-order": _vm.sortOrder,
              },
              on: { sort: _vm.sort },
            },
            [
              _vm._l(_vm.activeItems, function (item, index) {
                return _c(
                  "tr",
                  {
                    key: item.purchaseOrderItemId,
                    class: { "is-selected": _vm.selectedRow === index },
                  },
                  [
                    _c(
                      "td",
                      { staticClass: "has-vertical-middle itemdesc-input" },
                      [
                        !_vm.readOnlyView
                          ? _c("input", {
                              directives: [
                                {
                                  name: "focus-inserted",
                                  rawName: "v-focus-inserted",
                                },
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: item.description,
                                  expression: "item.description",
                                },
                              ],
                              staticClass: "input",
                              class: [
                                _vm.isDescEmpty(item.description)
                                  ? "is-danger"
                                  : "",
                              ],
                              attrs: {
                                placeholder: "Item Description",
                                disabled: _vm.isLockPurchaseOrder,
                              },
                              domProps: { value: item.description },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    item,
                                    "description",
                                    $event.target.value
                                  )
                                },
                              },
                            })
                          : _c("span", [_vm._v(_vm._s(item.description))]),
                      ]
                    ),
                    _c(
                      "td",
                      { staticClass: "has-vertical-middle partno-input" },
                      [
                        !_vm.readOnlyView
                          ? _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: item.partNo,
                                  expression: "item.partNo",
                                },
                              ],
                              staticClass: "input",
                              attrs: {
                                disabled: _vm.isLockPurchaseOrder,
                                placeholder: "Part Number",
                              },
                              domProps: { value: item.partNo },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(item, "partNo", $event.target.value)
                                },
                              },
                            })
                          : _c("span", [_vm._v(_vm._s(item.partNo))]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticClass:
                          "has-vertical-middle has-text-right qty-input",
                      },
                      [
                        !_vm.readOnlyView
                          ? _c("vue-numeric", {
                              staticClass: "input has-text-right",
                              attrs: {
                                min: 1,
                                disabled: _vm.isLockPurchaseOrder,
                                precision: 0,
                              },
                              on: {
                                input: function ($event) {
                                  return _vm.updateValue(index, item)
                                },
                              },
                              model: {
                                value: item.quantity,
                                callback: function ($$v) {
                                  _vm.$set(item, "quantity", _vm._n($$v))
                                },
                                expression: "item.quantity",
                              },
                            })
                          : _c("span", [_vm._v(_vm._s(item.quantity))]),
                      ],
                      1
                    ),
                    _c(
                      "td",
                      {
                        staticClass:
                          "has-vertical-middle has-text-right money-input",
                      },
                      [
                        !_vm.readOnlyView
                          ? _c("vue-numeric", {
                              staticClass: "input has-text-right",
                              attrs: {
                                min: 0,
                                disabled: _vm.isLockPurchaseOrder,
                                precision: 2,
                              },
                              on: {
                                input: function ($event) {
                                  return _vm.updateValue(index, item)
                                },
                              },
                              model: {
                                value: item.unitPrice,
                                callback: function ($$v) {
                                  _vm.$set(item, "unitPrice", _vm._n($$v))
                                },
                                expression: "item.unitPrice",
                              },
                            })
                          : _c("span", [_vm._v(_vm._s(item.unitPrice))]),
                      ],
                      1
                    ),
                    _c(
                      "td",
                      {
                        staticClass:
                          "has-vertical-middle has-text-right total-input",
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$filters.formatNumber(
                              item.quantity * item.unitPrice,
                              _vm.$userInfo.locale
                            )
                          )
                        ),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticClass:
                          "has-vertical-middle has-text-right qty-input",
                      },
                      [_vm._v(_vm._s(item.receivedQty - item.returnQty))]
                    ),
                    _c(
                      "td",
                      { staticClass: "has-vertical-middle has-text-centered" },
                      [
                        _c(
                          "button",
                          {
                            staticClass:
                              "button is-danger is-small is-inverted",
                            attrs: {
                              disabled:
                                _vm.readOnlyView || _vm.isLockPurchaseOrder,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.deleteItem(item, index)
                              },
                            },
                          },
                          [
                            _c("span", { staticClass: "icon is-medium" }, [
                              _c("i", {
                                staticClass: "mdi mdi-delete mdi-24px",
                              }),
                            ]),
                          ]
                        ),
                      ]
                    ),
                  ]
                )
              }),
              _c("template", { slot: "empty" }, [
                _c("section", { staticClass: "section" }, [
                  _c(
                    "div",
                    { staticClass: "content has-text-grey has-text-centered" },
                    [
                      _c("span", { attrs: { icon: "icon is-large" } }, [
                        _c("i", {
                          staticClass: "mdi mdi-48px mdi-emoticon-sad",
                        }),
                      ]),
                      _c("p", [_vm._v("Nothing")]),
                    ]
                  ),
                ]),
              ]),
              _c("template", { slot: "footer" }, [
                _c(
                  "tr",
                  {
                    staticClass: "no-border",
                    class: [
                      _vm.otherPurchasesTotal >= 0
                        ? `purchase-order-background-success-${_vm.$theme.name}`
                        : `purchase-order-background-danger-${_vm.$theme.name}`,
                    ],
                  },
                  [
                    _c(
                      "th",
                      {
                        staticClass: "has-text-left",
                        attrs: { colspan: _vm.totalColSpan },
                      },
                      [_vm._v("Totals")]
                    ),
                    _c("th", { staticClass: "has-text-right" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$filters.formatCurrency(
                            _vm.otherPurchasesTotal,
                            _vm.$userInfo.locale
                          )
                        )
                      ),
                    ]),
                    _c("th", { attrs: { colspan: _vm.blankColSpan } }),
                  ]
                ),
              ]),
            ],
            2
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }